// src/msalConfig.js
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { adminConsole } from './utils/adminConsole';
import { getAppUrl } from "./config/routePrefix";

const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID, // Application (client) ID from Azure AD
        authority: process.env.REACT_APP_AUTHORITY, // Directory (tenant) ID from Azure AD
        redirectUri: getAppUrl("/") // Your redirect URI
    },
    cache: {
        cacheLocation: "sessionStorage", // You can also use "localStorage"
        storeAuthStateInCookie: true, // Set this to true if you're having issues on IE11 or Edge
    },
    system: {
        allowNativeBroker: false
    }
};

const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.addEventCallback(event => {
    if ([EventType.LOGIN_START, EventType.LOGOUT_START, EventType.ACCOUNT_REMOVED,
        EventType.ACTIVE_ACCOUNT_CHANGED].filter(Boolean).includes(event.eventType)) {
        adminConsole.revoke();
    }
});
// await msalInstance.initialize();
// await msalInstance.handleRedirectPromise(); // This will no longer throw this error since initialize completed before this was invoked
// msalInstance.acquireTokenSilent(); // This will also no longer throw this error

export default msalInstance;
